<template>
	<svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M18.1316 15.5637L14.552 12.0586C14.3904 11.9004 14.1714 11.8125 13.9416 11.8125H13.3564C14.3473 10.5715 14.9362 9.01055 14.9362 7.3125C14.9362 3.27305 11.5935 0 7.46808 0C3.34269 0 0 3.27305 0 7.3125C0 11.352 3.34269 14.625 7.46808 14.625C9.20226 14.625 10.7964 14.0484 12.0638 13.0781V13.6512C12.0638 13.8762 12.1536 14.0906 12.3152 14.2488L15.8948 17.7539C16.2323 18.0844 16.7781 18.0844 17.112 17.7539L18.1281 16.759C18.4656 16.4285 18.4656 15.8941 18.1316 15.5637ZM7.46808 11.8125C4.92965 11.8125 2.87234 9.80156 2.87234 7.3125C2.87234 4.82695 4.92606 2.8125 7.46808 2.8125C10.0065 2.8125 12.0638 4.82344 12.0638 7.3125C12.0638 9.79805 10.0101 11.8125 7.46808 11.8125Z"
			fill="#B8CDD7" />
	</svg>

</template>

<script>
	export default {}
</script>

<style lang="scss" scoped>
	svg {
		cursor: pointer;

		path {
			transition: all 0.2s ease;
		}

		&:hover {
			path {
				fill: #8DA0A9;
			}
		}
	}
</style>